import type { FC } from "react";

import clsx from "clsx";

import { UICircularCheckbox } from "./style";

import Text from "../Text";
import Tooltip from "../Tooltip";

import { TextVariantsEnum } from "../types";

const CircularCheckbox: FC<{
	text: string;
	onClick: () => void;
	toolTipText: string;
	className?: string;
	active?: boolean;
}> = ({ text, onClick, toolTipText, className, active }) =>
	toolTipText ? (
		<Tooltip text={toolTipText} placement="bottom">
			<UICircularCheckbox className={clsx(className, active && "active")} onClick={onClick}>
				<Text variants={TextVariantsEnum.Caption3}>{text}</Text>
			</UICircularCheckbox>
		</Tooltip>
	) : (
		<UICircularCheckbox className={clsx(className, active && "active")} onClick={onClick}>
			<Text variants={TextVariantsEnum.Caption3}>{text}</Text>
		</UICircularCheckbox>
	);

export default CircularCheckbox;
